import { render, staticRenderFns } from "./TaxLayout.vue?vue&type=template&id=f22968aa&scoped=true&"
import script from "./TaxLayout.vue?vue&type=script&lang=js&"
export * from "./TaxLayout.vue?vue&type=script&lang=js&"
import style0 from "./TaxLayout.vue?vue&type=style&index=0&id=f22968aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22968aa",
  null
  
)

export default component.exports